import addVehicleSchema from './addVehicleSchema';

// Edit Vehicle has no plate fields; share Add Vehicle's optional VIN validation.
const editVehicleSchema = addVehicleSchema.pick(['VIN']);

export default editVehicleSchema;
